import { db } from 'wrFirebase/connection'
import { NODE_TYPES } from 'utils/constants'

const inventoryCollectionRef = db.collection('inventory')

export const inventoryQuery = (nodeId, nodeType) => {
	if (nodeType === NODE_TYPES.DISPENSARIES) {
		return inventoryCollectionRef.where('dispensary', '==', nodeId)
	}
	if (nodeType === NODE_TYPES.STRAINS) {
		return inventoryCollectionRef.where('strain', '==', nodeId)
	}
	return new Error('Bad nodeType for inventoryQuery')
}

export const pricesQuery = dispensaryId => {
	return db.collection('inventoryPrices').where('dispensary', '==', dispensaryId)
}
